import React, { useState, useEffect, useRef } from "react";
import WritingPad from "../UiElements/WritingPad";
import Alert from "@material-ui/lab/Alert";
import PieSocket from "piesocket-js/src/PieSocket";
import { useLocation } from "react-router-dom";
import firebase from "../../helpers/firebase";

function WriteAnswer() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const uniqueId = query.get("uniqueId");
  const sessionId = query.get("sessionId");
  const db = firebase.firestore();
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const pickSocketRef = useRef({ instance: null, channel: null });
  const [exerciseStatus, setExerciseStatus] = useState("");

  useEffect(() => {
    setLoading(false);
    pickSocketRef.current.instance = new PieSocket({
      clusterId: "free.blr2",
      apiKey: "J4A0fS044R5rlh24Uc0Mz5KlkFpWSKBbeOGa5OBG",
      notifySelf: true,
    });
    pickSocketRef.current.instance.subscribe("chat-room").then((channel) => {
      pickSocketRef.current.channel = channel;
      console.log("Channel is ready");
      pickSocketRef.current.channel.listen("submit_message", (data, meta) => {
        if (data?.status === "SUBMITTED" && data.unique_Id === uniqueId) {
          setExerciseStatus(data?.status);
        }
      });
      db.collection("sessions")
        .doc(sessionId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            let response = doc.data();
            pickSocketRef.current.channel.publish("new_message", {
              latex: "",
              mathml: "",
              asciimath: "",
              unique_Id: uniqueId,
              sessionId: sessionId,
              status: response?.status,
            });
            setExerciseStatus(response?.status);
          }
        });
    });

    return pickSocketRef.current?.instance?.disconnect?.();
  }, []);

  const submitAnswer = (data) => {
    setAnswer(data);
    if (data["latex"] && data["mathml"]) {
      pickSocketRef.current.channel.publish("new_message", {
        latex: data.latex,
        mathml: data.mathml,
        asciimath: data.asciimath,
        unique_Id: uniqueId,
        sessionId: sessionId,
        status: "TEST_STARTED",
      });
    } else {
      setError("Can not read the answer");
    }
  };

  const handleUndo = () => {
    setLoading(true);
    pickSocketRef.current.channel.publish("new_message", {
      latex: "",
      mathml: "",
      asciimath: "",
      unique_Id: uniqueId,
      is_undo: true,
      status: "TEST_STARTED",
    });

    setLoading(false);
  };

  const renderWhiteBoard = (status) => {
    switch (status) {
      case "WAITING_STUDENTS":
        return <h2>awaiting an exercise</h2>;
      case "SUBMITTED":
        return <h2>submitted</h2>;
      case "TEST_STARTED":
        return (
          <WritingPad
            submitBtnText="Enter"
            onSubmit={submitAnswer}
            onUndo={handleUndo}
            fullScreen={true}
            role="Student"
          />
        );
      case "TEST_END":
        return <h2>submitted</h2>; 
      default:
        break;
    }
  };

  return (
    <>
      {error && (
        <Alert className="error-top" severity="error">
          {error}
        </Alert>
      )}
      <div>{exerciseStatus ? renderWhiteBoard(exerciseStatus) : null}</div>
    </>
  );
}

export default WriteAnswer;
